<template>
  <div
    class="bracket-participant"
    :class="{ 'loading-opacity': loading }"
    @click="showTeamRoster"
  >
    <div class="bracket-participant__content">
      <template v-if="participant">
        <span class="bracket-participant__name">{{ participant.name }}</span>
      </template>

      <span v-else class="bracket-participant__name"></span>

      <div v-if="!result" class="bracket-participant__score">
        {{ participant && score }}
      </div>

      <div class="bracket-participant__line-before" />
      <div class="bracket-participant__line-after" />
    </div>
  </div>
</template>

<script>
import { openModal } from "@/components/teams/TeamView";
import service from "@/services/team";

export default {
  name: "BracketCardParticipant",
  props: {
    result: Boolean,
    participant: {
      type: Object
    },
    score: {
      type: [String, Number]
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async showTeamRoster() {
      const { participant } = this;
      if (!participant || this.loading) return;
      this.loading = true;
      const { data, success } = await service.getTeamDetails(participant.id);
      if (success) {
        openModal(data);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
$border-color: colors(palette-2);
$p: ".bracket-participant";

.bracket-participant {
  height: 44px;
  border-radius: 4px;
  background-color: currentColor;
  margin: auto 0;

  &__content {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    padding-right: 50px;
  }

  .bracket-card:last-child & {
    &:first-child {
      color: colors(palette-2);
    }
    &:nth-child(2) {
      color: colors(palette-4);
    }
  }

  .bracket-card:first-child & {
    &:first-child {
      color: colors(palette-4);
    }
    &:nth-child(2) {
      color: colors(palette-2);
    }
  }

  &__score {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 2px;
    top: 2px;
    bottom: 2px;
    width: 40px;
    background-color: colors(palette-1);
    font-size: 24px;
    font-weight: fw(bold);
    border-radius: 4px;
  }

  &__name {
    font-size: 18px;
    font-weight: fw(bold);
    @include text-ellipsis();
    max-width: 100%;
    color: colors(text-3);
    padding-right: 10px;
    text-transform: uppercase;
    padding-left: 20px;
  }

  &__img-container {
    margin-right: 10px;
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    background-color: #aabbd0;
  }

  &__img {
    width: 100%;
    height: 100%;
  }

  &__wrapper {
    position: relative;
    width: 100%;
  }

  &:hover {
    background-color: colors(palette-3);
  }

  &__line-before,
  &__line-after {
    position: absolute;
    top: calc(50% - 2px);
    width: 15px;
    height: 2px;
    background-color: $border-color;
  }

  &__line-before {
    right: 100%;
  }

  &__line-after {
    left: 100%;
  }
  &::after {
    content: "";
    position: absolute;
    z-index: 1;
    right: -15px;
    height: 25%;
    width: 2px;
    background-color: $border-color;
    pointer-events: none;
  }

  &:first-child {
    &::after {
      top: 25%;
    }
  }

  &:nth-child(2) {
    &::after {
      bottom: 25%;
    }
  }

  .brackets-grid__round:last-child & {
    &::after,
    &__line-after {
      display: none;
    }
  }
}
</style>
